"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var flyout_1 = require("spry-react/Flyout/flyout");
var htmlUtils_1 = require("spry-react/utils/htmlUtils");
var buttonKeyPressHandler_1 = require("spry-react/utils/buttonKeyPressHandler");
var react_1 = require("react");
var idGenerator_1 = require("spry-react/utils/idGenerator");
//Useful for controls that manage their own keyboard/accessibility/focus support
var FlyoutClickToggle = /** @class */ (function (_super) {
    __extends(FlyoutClickToggle, _super);
    function FlyoutClickToggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleContentClicked = function (e) {
            if (!_this.props.disabled) {
                _this.props.toggleClickHandler();
            }
        };
        _this.onClickOutsideFlyoutHandler = function (clickedElement) {
            if (!_this.toggleElement || (clickedElement !== _this.toggleElement && !htmlUtils_1.contains(clickedElement, _this.toggleElement))) {
                _this.props.onClickOutsideFlyout(clickedElement);
            }
        };
        return _this;
    }
    FlyoutClickToggle.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, flyout = _a.flyout, disabled = _a.disabled, disableFocusLock = _a.disableFocusLock;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { onClick: this.toggleContentClicked, ref: function (element) { return _this.toggleElement = element; } }, children),
            React.createElement(flyout_1.Flyout, { flyout: flyout, onClickOutsideFlyout: this.onClickOutsideFlyoutHandler, disableFocusLock: (disableFocusLock !== null && disableFocusLock !== void 0 ? disableFocusLock : true) })));
    };
    return FlyoutClickToggle;
}(React.Component));
exports.FlyoutClickToggle = FlyoutClickToggle;
function isButtonToggledFlyoutDescriptor(flyoutOrDescriptor) {
    var _a;
    return !!((_a = flyoutOrDescriptor) === null || _a === void 0 ? void 0 : _a.contents);
}
exports.isButtonToggledFlyoutDescriptor = isButtonToggledFlyoutDescriptor;
function FlyoutButtonToggle(props) {
    var _a;
    var children = props.children, flyout = props.flyout, disabled = props.disabled, toggleClickHandler = props.toggleClickHandler, onClickOutsideFlyout = props.onClickOutsideFlyout;
    var toggleElement = react_1.useRef(null);
    var id = react_1.useRef((_a = props.id, (_a !== null && _a !== void 0 ? _a : idGenerator_1.GenerateId())));
    var isOpen = !!flyout;
    return React.createElement(React.Fragment, null,
        React.createElement("div", { id: id.current, onClick: !disabled ? toggleClickHandler : function () { }, onKeyPress: !disabled ? buttonKeyPressHandler_1.buttonKeyPressHandler(toggleClickHandler) : function () { }, tabIndex: 0, role: "button", "aria-disabled": disabled, "aria-haspopup": true, "aria-expanded": isOpen, ref: toggleElement, style: props.style }, children),
        React.createElement(flyout_1.Flyout, { flyout: isOpen ? getFlyoutDescriptor(flyout, id.current) : null, onClickOutsideFlyout: function (clickedElement) {
                if (!toggleElement.current || (clickedElement !== toggleElement.current && !htmlUtils_1.contains(clickedElement, toggleElement.current)))
                    onClickOutsideFlyout(clickedElement);
            }, disableFocusLock: false }));
}
exports.FlyoutButtonToggle = FlyoutButtonToggle;
function getFlyoutDescriptor(flyout, positioningElementId) {
    return isButtonToggledFlyoutDescriptor(flyout)
        ? __assign(__assign({}, flyout), { positioningElementId: positioningElementId, key: "flyout-" + positioningElementId }) : {
        contents: flyout,
        positioningElementId: positioningElementId,
        key: "flyout-" + positioningElementId
    };
}
